module.exports = __webpack_public_path__ + "static/media/iconPaymentActive.05e08ca0.svg";